import { ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119 } from "@faire/web-api/indigofair/settings/ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119";
import { EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS } from "@faire/web-api/indigofair/settings/EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS";
import { HCAPTCHA_FRONTEND_TIMEOUT_MS } from "@faire/web-api/indigofair/settings/HCAPTCHA_FRONTEND_TIMEOUT_MS";

import {
  getSettingValueAndAssign,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingHCaptchaTimeoutMS = (): number =>
  getSettingValueWithoutAssignment(HCAPTCHA_FRONTEND_TIMEOUT_MS, 1000);

export const getSettingAndAssignEnableExperimentalLoginLatencyInterventions =
  (): boolean =>
    getSettingValueAndAssign(
      ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119,
      false
    );

export const getSettingExperimentalHCaptchaTimeoutMS = (): number =>
  getSettingValueWithoutAssignment(
    EXPERIMENTAL_HCAPTCHA_FRONTEND_TIMEOUT_MS,
    1000
  );
